import { COLORS } from 'consts/colors'
import styled from 'styled-components'

export const MultiLineDndContainer = styled.div`
  display: flex;
  flex-direction: column;
  & .adding-drop-line {
    visibility: hidden;
  }
`

export const DropLine = styled.div<{ $isVisible: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;
  margin-bottom: 6px;
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
`

export const DropIndicator = styled.div`
  display: none;
  position: absolute;
  top: 0;
  height: 100%;
  background-color: ${COLORS.primaryDark};
  border: 1px solid ${COLORS.borderColor};
  opacity: 0.2;
  border-radius: 4px;
  pointer-events: none;
`
